// CrYsp Global JS

// Track quantities per variant for collection page steppers
var cardQtys = {};

// Add to cart via AJAX — with stepper support on collection cards
async function addToCart(variantId, btn) {
  if (!variantId) return;

  // Check if this button is on a collection card (has prod-card__btn class)
  var isCollectionCard = btn && btn.classList.contains('prod-card__btn');

  if (isCollectionCard) {
    // Collection card — replace button with stepper
    btn.disabled = true;
    btn.textContent = '...';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });

      cardQtys[variantId] = 1;

      // Build stepper and replace button
      var stepper = document.createElement('div');
      stepper.style.cssText = 'display:inline-flex;align-items:center;border:1.5px solid #1a3a35;border-radius:999px;overflow:hidden;background:white;width:fit-content;flex-shrink:0;vertical-align:middle;line-height:1;align-self:center;';
      stepper.innerHTML =
        '<button type="button" style="background:none;border:none;width:32px;height:32px;font-size:1.1rem;font-weight:700;color:#1a3a35;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;vertical-align:middle;line-height:1;padding:0;" onclick="cardStep(\'' + variantId + '\',-1,this)">−</button>' +
        '<span style="min-width:28px;text-align:center;font-size:0.88rem;font-weight:700;color:#1a3a35;" class="dyn-sval">1</span>' +
        '<button type="button" style="background:none;border:none;width:32px;height:32px;font-size:1.1rem;font-weight:700;color:#1a3a35;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;vertical-align:middle;line-height:1;padding:0;" onclick="cardStep(\'' + variantId + '\',1,this)">+</button>';

      stepper._addBtn = btn;
      btn.parentElement.replaceChild(stepper, btn);

      // Update cart badge
      const cart = await (await fetch('/cart.js')).json();
      updateCartBadge(cart.item_count);
      showToast('✓ Added to cart');

    } catch(e) {
      btn.textContent = '+ Add';
      btn.disabled = false;
    }

  } else {
    // Other pages (product page etc) — original behaviour
    const original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = '✓'; btn.style.background = '#00a896'; }
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      const cart = await (await fetch('/cart.js')).json();
      updateCartBadge(cart.item_count);
      showToast('✓ Added to cart');
    } catch(e) {
      console.error(e);
    }
    setTimeout(() => {
      if (btn) { btn.textContent = original; btn.style.background = ''; }
    }, 1500);
  }
}

// Stepper step function for collection cards
async function cardStep(variantId, dir, stepBtn) {
  var current = cardQtys[variantId] || 1;
  var next = current + dir;
  var stepper = stepBtn.parentElement;

  if (next <= 0) {
    cardQtys[variantId] = 0;
    try {
      var updates = {};
      updates[variantId] = 0;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } catch(e) {}

    // Restore Add button
    var addBtn = stepper._addBtn;
    if (!addBtn) {
      addBtn = document.createElement('button');
      addBtn.className = 'prod-card__btn';
      addBtn.textContent = '+ Add';
      addBtn.setAttribute('onclick', "addToCart('" + variantId + "', this)");
    }
    addBtn.disabled = false;
    addBtn.textContent = '+ Add';
    addBtn.style.display = '';
    stepper.parentElement.replaceChild(addBtn, stepper);

    const cart = await (await fetch('/cart.js')).json();
    updateCartBadge(cart.item_count);
    return;
  }

  cardQtys[variantId] = next;
  var valEl = stepper.querySelector('.dyn-sval');
  if (valEl) valEl.textContent = next;

  try {
    var updates = {};
    updates[variantId] = next;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    const cart = await (await fetch('/cart.js')).json();
    updateCartBadge(cart.item_count);
  } catch(e) {}
}

window.updateCartBadge = function(count) {
    const countEls = document.querySelectorAll('.crysp-nav__cart-count');
  countEls.forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

// Toast
function showToast(msg) {
  const t = document.getElementById('cartToast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2500);
}
